class CommandHandler {
    gameEventEmitter;
    uiEventEmitter;
    text;
    itemsJson;
    /**
     * @param {EventEmitter} gameEventEmitter
     * @param {EventEmitter} uiEventEmitter
     * @param {TextModel} text
     * @param {{ [key: string]: any }} itemsJson
     */
    constructor(gameEventEmitter, uiEventEmitter, text, itemsJson) {
        this.gameEventEmitter = gameEventEmitter;
        this.uiEventEmitter = uiEventEmitter;
        this.text = text;
        this.itemsJson = itemsJson;
    }
    /**
     * Handle each interaction. Check what command is coming in, and do the thing.
     * Timeouts are done in handle_commands. Order of commands in interactions.json
     * can be important.
     * @param {object} command the interaction command as json
     */
    handleCommand(command) {
        if (command.command == "monologue") {
            const text = this.text.getText(command.textkey.object, command.textkey.string);
            const posture = command.posture || null;
            this.gameEventEmitter.emit('monologue', { text, posture });
        }
        else if (command.command == "inventory_add") {
            const items = Array.isArray(command.item) ? command.item : [command.item];
            const itemsToAdd = [];
            items.forEach((name) => itemsToAdd.push({ name, category: this.itemsJson[name].category }));
            this.gameEventEmitter.emit('inventory_add', itemsToAdd);
        }
        else if (command.command == "inventory_remove") {
            const items = Array.isArray(command.item) ? command.item : [command.item];
            const itemsToRemove = [];
            items.forEach((name) => itemsToRemove.push(name));
            this.gameEventEmitter.emit('inventory_remove', itemsToRemove);
        }
        else if (command.command == "remove_object") {
            const objects = Array.isArray(command.object) ? command.object : [command.object];
            const objectsToRemove = [];
            objects.forEach((objectName) => {
                objectsToRemove.push(objectName);
            });
            this.gameEventEmitter.emit('remove_objects', objectsToRemove);
        }
        else if (command.command == "add_object") {
            const objects = Array.isArray(command.object) ? command.object : [command.object];
            const objectNames = [];
            objects.forEach((objectName) => {
                objectNames.push(objectName);
            });
            const roomId = command.room;
            this.gameEventEmitter.emit('add_objects', { objectNames, roomId });
        }
        else if (command.command == "do_transition") {
            this.uiEventEmitter.emit('ready_transition', ({
                type: command.instant ? 'instant' : 'regular',
                roomId: command.destination
            }));
            this.gameEventEmitter.emit('do_transition', {
                roomId: command.destination
            });
        }
        else if (command.command == "play_sequence") {
            this.gameEventEmitter.emit('play_sequence', command.sequence);
        }
        else if (command.command == "change_character_posture") {
            this.gameEventEmitter.emit('change_character_posture', command.posture);
        }
        else if (command.command == "npc_monologue") {
            const npc = command.npc;
            const text = this.text.getText(command.textkey.object, command.textkey.string);
            const characterPosture = command.character_posture || null;
            this.gameEventEmitter.emit('npc_monologue', { npc, text, characterPosture });
        }
        else if (command.command === 'play_full_fade_out') {
            this.uiEventEmitter.emit('play_full_fade_out');
        }
        else if (command.command === 'play_full_fade_in') {
            this.uiEventEmitter.emit('play_full_fade_in');
        }
        else {
            console.warn("Unknown interaction command " + command.command);
        }
    }
}

export { CommandHandler };
//# sourceMappingURL=CommandHandler.js.map
